import React from 'react'
import {createRoot, hydrateRoot} from 'react-dom/client'
import {BrowserRouter} from 'react-router-dom'
import './index.css'
import App from './App'

const rootElement = document.getElementById('root')
const app = <BrowserRouter><App /></BrowserRouter>
// Reuse the build-time HTML without creating a second React root.
if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, app)
} else {
    createRoot(rootElement).render(app)
}
